import { render, staticRenderFns } from "./v-icon.vue?vue&type=template&id=c41280fa&scoped=true&"
import script from "./v-icon.vue?vue&type=script&lang=js&"
export * from "./v-icon.vue?vue&type=script&lang=js&"
import style0 from "./v-icon.vue?vue&type=style&index=0&id=c41280fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41280fa",
  null
  
)

export default component.exports